// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"7f1dedc4","348":"cf17dcbc","571":"787d6ef8","924":"61e02fcc"}[chunkId] + ".chunk.js";
};